/* 
 *  Created by SGiri 02/26/2018
 */

import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { saveAs } from 'file-saver/FileSaver';
import { FormControl, Validators } from '@angular/forms';
import { DashboardService } from '~config/services/dashboard.service';
import { SearchService } from '~config/services/search.service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {

  header: string;
  action: string;
  name = new FormControl('', Validators.required);
  releaseVersion = new FormControl(null, Validators.required);
  isDisabled: boolean = false;
  buttonText: string = 'Export';
  releaseVersions: string[];

  constructor(public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private dService: DashboardService, private sService: SearchService) {
  }

  ngOnInit() {

    if (this.data.dashboard) {
      this.header = 'Add Global Dashboard';
      this.action = 'save';
    } else {
      this.header = 'Export For Release';
      this.action = 'export';
      this.sService.getReleaseVersions(true).subscribe((data: string[]) => {
        this.releaseVersions = data;
      });
    }
  }

  save() {
    if (this.name.valid && this.releaseVersion.valid) {
      let dashbaord = {
        dashboardName: this.name.value,
        releaseVersion: this.releaseVersion.value
      }
      this.dService.saveNewDashboard(dashbaord).subscribe(data => {
        this.dialogRef.close(data);
      });
    }
    return;
  }

  export() {
    if (this.releaseVersion.valid) {
      this.isDisabled = true;
      this.buttonText = 'Exporting..';
      this.sService.exportForRelease(this.releaseVersion.value).subscribe((data: string) => {
        this.isDisabled = false;
        this.buttonText = 'Export';
        if (data != 'NO_DATA') {
          var blob = new Blob([data], { type: 'application/sql' });
          saveAs(blob, 'BI_REPORTING_CONFIG_RELEASE_SCRIPT.sql');
          this.dialogRef.close();
        } else {
          this.releaseVersion.setErrors({ invalid: true })
          return;
        }
      });
    }
    return;
  }

  getErrorMessage() {
    return this.releaseVersion.hasError('required') ? 'Please select Release Version' :
      this.releaseVersion.hasError('invalid') ? 'Not a valid Release Version or no changes for this release' : '';
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/dashboard-detail/dialog/dialog.component.ts